// Les dossiers : la page Dossiers (V4Projets) et le portefeuille (V4Portfolio).
export default {
  titre: 'Dossiers',
  sousTitre: 'Ce que vous suivez : ses marques, sa matière, son périmètre',
  erreur: {
    illisible: 'Dossier illisible',
    creation: 'Création impossible',
    changement: 'Changement impossible',
    envoi: 'Envoi impossible',
    depot: 'Dépôt impossible',
    suppression: 'Suppression impossible',
  },
  dimension: {
    pyramide: 'répartition par âge',
    femmes: 'part de femmes par âge',
    diplome: 'diplôme',
    urbanite: 'lieu de vie',
    origine: 'origine',
    religion: 'religion',
  },
  // Les genres de matière : le libellé du bouton, son aide, et la pastille de la liste.
  kind: {
    brief: { l: 'brief', aide: 'un brief, un cahier des charges, une demande' },
    presentation: { l: 'présentation', aide: 'un deck, une présentation, un pitch' },
    bible: { l: 'bible', aide: 'la bible, le concept, le format papier' },
    script: { l: 'script', aide: 'un script, un conducteur, un séquencier' },
    sondage: { l: 'sondage', aide: 'des chiffres sur une population, avec une date de terrain' },
    etude: { l: 'étude', aide: 'une analyse, un rapport, un usage et attitudes' },
    donnees: { l: 'données', aide: 'un export, un tableau, des audiences' },
    presse: { l: 'presse', aide: 'un article, une revue de presse' },
    veille: { l: 'veille', aide: 'la concurrence, un benchmark' },
    compte_rendu: { l: 'compte rendu', aide: 'le compte rendu d’une réunion' },
    contrat: { l: 'contrat', aide: 'un contrat, un appel d’offres' },
    note: { l: 'note', aide: 'ce que vous savez et qui n’est écrit nulle part' },
    media: { l: 'média', aide: 'une affiche, un spot, un teaser' },
  },
  // La pastille montre la valeur telle quelle en français (en capitales).
  pastille: {
    brief: 'brief',
    presentation: 'presentation',
    bible: 'bible',
    script: 'script',
    presse: 'presse',
    veille: 'veille',
    compte_rendu: 'compte rendu',
    contrat: 'contrat',
    sondage: 'sondage',
    etude: 'etude',
    donnees: 'donnees',
    note: 'note',
    media: 'media',
  },
  choix: {
    titre: 'Vos dossiers',
    texte: 'Un dossier est ce que vous suivez : une émission, un film, une gamme. Il porte ses marques, la matière que vous y déposez, et les territoires qu’il a le droit de regarder. Tant qu’aucun n’est ouvert, il n’y a rien à afficher.',
    marques: '{n} marque(s)',
    territoires: '{n} territoire(s)',
  },
  archive: 'archivé',
  creer: {
    aide: 'Créer un dossier',
    bouton: 'Nouveau dossier',
    nom: 'Le nom du dossier - The Voice, Koh-Lanta…',
    description: 'De quoi il s’agit. Ce texte part dans le cadrage des études.',
    marche: 'le marché décide de la population tirée',
    enCours: 'création…',
    valider: 'Créer',
  },
  annuler: 'annuler',
  changer: 'changer de dossier',
  marques: {
    titre: 'Marques · {n}',
    ajouter: 'ajouter une marque',
    aucune: 'Aucune marque. Un dossier sans marque n’a rien à auditer - c’est le premier geste.',
  },
  territoires: {
    titre: 'Territoires · {n}',
    aucun: 'Aucun territoire. Ceux de vos marques remontent ici dès qu’un audit les détecte.',
    principal: 'principal',
    via: 'via {liste}',
    uneMarque: 'une marque',
    ouvert: 'ouvert au dossier',
  },
  matiere: {
    titre: 'Ce que vous avez déposé · {n}',
    aideDeposer: 'Déposer une étude, un sondage, un export ou une note',
    deposer: 'déposer',
    confidentialite: 'Cette matière reste dans ce dossier. Elle ne rejoint ni les territoires partagés, ni le banc d’Orion : une étude que vous avez payée ne règle pas le moteur d’un autre.',
    aideEnvoi: 'Envoie le fichier dans le seau privé du dossier',
    envoi: 'envoi…',
    remplacer: 'remplacer le fichier',
    choisir: 'choisir un fichier',
    envoye: '✓ envoyé',
    ouColler: 'ou collez le texte plus bas',
    titreDoc: 'Le titre - ce que c’est, en clair',
    auteur: 'Qui l’a produit (institut, cabinet)',
    dateTerrain: 'La date de TERRAIN, pas de publication',
    population: 'Qui a répondu - « 1 002 Français de 18 ans et plus »',
    texte: 'Ou collez directement le texte : une note vaut une étude, et elle est souvent plus à jour.',
    depotEnCours: 'dépôt…',
    deposerEtLire: 'Déposer et lire',
    incomplet: 'Il faut un titre, et un fichier ou du texte.',
    rien: 'Rien de déposé. Les études que vous avez déjà payées et les sondages de la saison passée cadrent les panels de ce dossier - sans eux, Orion part de ce qu’il sait du monde, pas de vous.',
    lecture: 'lecture en cours…',
    illisible: 'illisible',
    aideRetirer: 'Les panels du dossier ne le liront plus',
    aideRemettre: 'Les panels du dossier le reliront',
    retirer: 'retirer du contexte',
    remettre: 'remettre',
    aideSupprimer: 'Retire le document du dossier',
    supprimer: 'supprimer',
    terrain: 'terrain {date}',
  },
  population: {
    titre: 'Qui on interroge dans ce dossier',
    avant: 'Ce que vous avez déposé et validé décide de la composition des ISOs tirés ici. Ce qui n’est pas documenté reste celui du territoire. Vos chiffres corrigent',
    qui: 'qui',
    apres: 'on interroge, jamais ce qu’ils répondent : ajuster les réponses reviendrait à régler l’instrument sur un résultat déjà connu.',
    terrain: 'terrain {date}',
    sansDate: 'sans date de terrain',
  },
  chiffres: {
    titre: 'Chiffres à relire · {n}',
    valides: '{n} validé(s)',
    texte: 'Chaque chiffre lu dans vos documents attend votre relecture avant de servir à mesurer Orion. Un « 38 % » lu là où il y avait « 3,8 sur 8 » dirait au moteur qu’il se trompe alors qu’il a raison, et on corrigerait dans le mauvais sens sans que rien ne cloche.',
    misAJour: 'Population du dossier mise à jour : {n} lignes. Les ISOs tirés ici suivent désormais cette composition.',
    audience: 'décrit votre audience',
    avertissement: 'Valider ce chiffre changera la composition des ISOs tirés dans ce dossier.',
    terrain: 'terrain {date}',
    justeTirer: 'le chiffre est juste, tirez dessus',
    juste: 'le chiffre est juste',
    malLu: 'mal lu',
    validesTitre: 'Validés',
  },
  archiver: {
    aideArchiver: 'Le dossier et sa matière restent, rangés',
    aideReactiver: 'Le dossier revient parmi les actifs',
    archiver: 'archiver ce dossier',
    reactiver: 'réactiver ce dossier',
  },
  chargement: 'Chargement du dossier…',
  poids: {
    mo: '{n} Mo',
    ko: '{n} Ko',
  },

  // ── Le portefeuille ───────────────────────────────────────────────────────
  portefeuille: {
    titre: 'Portefeuille',
    nbDossiers: '{n} dossier | {n} dossier | {n} dossiers',
    nbMarques: '{n} marque | {n} marque | {n} marques',
    insight: 'Insight du jour',
    whiteSpace: 'White space détecté sur {marque} - « {label} »',
    whiteSpaceAngle: 'White space détecté sur {marque} - « {label} » : {angle}',
    dossier: 'dossier {nom}',
    detection: 'détection {date}',
    detectionAide: 'White space auto-détecté sur les signaux des 90 derniers jours',
    force: 'force {n}/100',
    forceAide: "Score d'opportunité du white space - voir le brief éditorial",
    ouvrirDossier: 'Ouvrir le dossier',
    ouvrirChaine: 'Ouvrir la chaîne',
    masquer: "Masquer cet insight - rien n'est supprimé en base, il réapparaît si un nouveau white space est détecté",
    ouvrirDeepDive: 'Ouvrir le deep-dive',
    compare: "Comparé à l'audit précédent - {source}",
    mesDossiers: 'Mes dossiers · {n}',
    porte: 'Un dossier porte ses marques, ce que vous y déposez, et les territoires qu’il regarde.',
    creerAide: 'Créer un dossier - une émission, un film, une gamme',
    nouveau: 'Nouveau dossier',
    ouvert: 'dossier ouvert',
    scoreAide: 'Score de marque / 100',
    aAnalyser: 'à analyser',
    autres: '+ {n} autre(s)',
    aucuneMarque: 'Aucune marque - c’est le premier geste.',
    territoiresAide: 'Territoires du dossier - ceux de ses marques y remontent, et ceux qu’un administrateur lui ouvre',
    territoires: 'territoire | territoire | territoires',
    deposesAide: 'Ce que vous avez déposé et qui cadre les études du dossier',
    deposes: 'déposé | déposé | déposés',
    isosAide: 'ISOs qui sortent chaque jour, Arène et Grille, toutes marques du dossier',
    isosJour: 'ISOs / jour',
    aucun: 'Aucun dossier. Un dossier est ce que vous suivez : une émission, un film, une gamme - il porte ses marques, la matière que vous y déposez et les territoires qu’il regarde.',
    sansDossier: 'Marques sans dossier · {n}',
  },
}
